import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-schedules-on-profile-actions-modal',
    templateUrl: './schedules-on-profile-actions-modal.component.html'
})
export class SchedulesOnProfileActionsModalComponent implements OnInit {
    actionType: any;
    actionLabel: any;
    jobMatchId: any;
    candidateId: any;
    meetingScheduleId: any;
    externalMeetingCallId: any;
    sourceScreen: any;
    formalizeActivityPayload: any;
    callbackObject: any;
    public onClose: Subject<any>;

    constructor(
        private bsModalRef: BsModalRef,
        public bsModalService: BsModalService
    ) {
        this.onClose = new Subject();
    }

    ngOnInit(): void {
        const modalData: any = this.bsModalService.config.initialState || {};
        this.actionType = modalData.actionType;
        this.actionLabel = modalData.actionLabel;
        this.jobMatchId = modalData.jobMatchId;
        this.candidateId = modalData.candidateId;
        this.meetingScheduleId = modalData.meetingScheduleId;
        this.externalMeetingCallId = modalData.externalMeetingCallId;
        this.sourceScreen = modalData.sourceScreen;
        this.formalizeActivityPayload = modalData.formalizeActivityPayload;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }

    closeModal(): void {
        this.onClose.next(this.callbackObject);
        this.bsModalRef.hide();
    }

    dismissModal(): void {
        this.bsModalRef.hide();
    }

    moveCandidateCallback(): void {
        this.callbackObject.callbackType = 'moveCandidate';
        this.closeModal();
    }
}
